import { Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatSortModule} from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {  MatInputModule } from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

import { DatePipe, NgOptimizedImage } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

import { firstValueFrom } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';

import { MatButton } from '@angular/material/button';

import { MatDialog } from '@angular/material/dialog';

import { MatProgressBar } from '@angular/material/progress-bar';

import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog';

import { CarouselImagesStore } from '@data-access/manager/stores/carousel-manager.store';
import { CarouselImage } from '@shared/interfacres/image';
import { UploadImageDialog } from './upload-image-dialog/upload-image-dialog';


@Component({
  selector: 'app-carousel-images',
  templateUrl: './carousel-images.html',
  styleUrl: './carousel-images.scss',

  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule,
    DatePipe, MatIcon, ReactiveFormsModule, MatProgressBar, MatButton, NgOptimizedImage],
})
export class CarouselImages implements OnInit {
  displayedColumns: string[] = ['id', 'image', 'actions'];
  dataSource: CarouselImage[] = [];
  total = 0;


  readonly store = inject(CarouselImagesStore);
  private destroyRef = inject(DestroyRef);
  readonly dialog = inject(MatDialog);

  constructor(
  ) {

    effect(() => {
      this.dataSource = this.store.items();
      this.total = this.store.total();
    });
  }

  ngOnInit(): void {
    this.store.getAll();
  }

  async add() {

    const dialogRef = this.dialog.open(UploadImageDialog, {
      data: null,
      disableClose: true,
      // width: '500px',
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'

    });

    const result = await firstValueFrom(dialogRef.afterClosed());

    if (result) {
      this.store.create(result);
    }
  }

  async edit(item: CarouselImage) {
    // const imageLink = item.image ? await firstValueFrom(this.store.getImageById(item.id)) : '';

    const dialogRef = this.dialog.open(UploadImageDialog, {
      data: {
        ...item
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });

    const result = await firstValueFrom(dialogRef.afterClosed());

    if (result) {
      this.store.update(item.id, result);
    }
  }

  async confirmDelete(image: CarouselImage) {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: {
        title: 'Delete?',
        message: 'Are you sure you want to remove this image?'
      },
      disableClose: true,
      panelClass: 'admin-dialog',
      backdropClass: 'admin-dialog-backdrop'
    });


    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      this.store.delete(image.id);
    }

  }
}
